import { LANGUAGES } from "../../../../config/languages";
import { nationalities_en } from "../constants/nationalities_en";
import { nationalities_es } from "../constants/nationalities_es";

export const NationalityMap = {
  byLanguage: (language) => {
    if (language === LANGUAGES.english) return nationalities_en;
    return nationalities_es;
  },
};
